/**
 * Utility formatters for distance, dates, and other display values
 */

/**
 * Format distance for display
 * @param {number} meters - Distance in meters
 * @returns {string} Formatted distance string (e.g., "150m" or "2.5km")
 */
export const formatDistance = (meters) => {
    if (meters === undefined || meters === null) return '';

    // Convert to km if >= 1000m
    if (meters >= 1000) {
        const km = meters / 1000;
        return `${km.toFixed(1)}km`;
    }

    // Display in meters for short distances
    return `${Math.round(meters)}m`;
};

/**
 * Check if a timestamp is recent (within specified days)
 * @param {string|Date} timestamp - ISO timestamp or Date object
 * @param {number} daysThreshold - Number of days to consider "recent" (default: 7)
 * @returns {boolean} True if timestamp is within threshold
 */
export const isRecent = (timestamp, daysThreshold = 7) => {
    if (!timestamp) return false;

    const date = new Date(timestamp);
    const now = new Date();
    const diffTime = Math.abs(now - date);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    return diffDays <= daysThreshold;
};

/**
 * Get days since timestamp
 * @param {string|Date} timestamp - ISO timestamp or Date object
 * @returns {number} Number of days since timestamp
 */
export const getDaysSince = (timestamp) => {
    if (!timestamp) return null;

    const date = new Date(timestamp);
    const now = new Date();
    const diffTime = Math.abs(now - date);
    return Math.floor(diffTime / (1000 * 60 * 60 * 24));
};

/**
 * Format currency (JPY)
 * @param {number} amount - Amount in yen
 * @returns {string} Formatted currency string
 */
export const formatCurrency = (amount) => {
    if (amount === undefined || amount === null) return '¥0';
    return `¥${amount.toLocaleString()}`;
};
